import React from "react";
import { IWPLink } from "@/src/types";
import { ImageDataLike } from "gatsby-plugin-image";

import S from "./NewsArchive.styled";
import { getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import { usePostsData } from "./usePostData";

import { useLocalization } from "../../../contexts/Localization";

export interface Props {
  title: string;
  ctaLink?: IWPLink;
}

type Post = {
  title: string;
  url: string;
  slug: string;
  date: string;
  uri: string;
  published_at: string;
  excerpt: string;
  description: string;
  image_url: string;
  featuredImage: {
    node: {
      altText: string;
      sourceUrl: string;
      title: string;
      gatsbyImage: ImageDataLike;
    };
  };
  contentType: {
    node: {
      graphqlSingleName: string;
    };
  };
};

const NewsArchive: React.FC<Props> = ({}) => {
  const { language } = useLocalization();
  const posts = usePostsData(language);

  return (
    <div className="article-library">
      <div className=" md:mx-auto md:max-w-7xl px-6 md:px-0 py-12 block md:grid grid-cols-4 gap-4 nyheterPageArticles">
        {posts.map((post: Post, idx: number) => {
          var date = new Date(post.date)
            .toLocaleString("en-us", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
            .replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");

          var postImageData = post.featuredImage?.node?.gatsbyImage
            ? getImage(post.featuredImage.node.gatsbyImage)
            : null;

          return (
            <Link to={post.uri} key={idx}>
              <S.Post>
                <div
                  className={
                    "relative h-full my-4 bg-white rounded-md overflow-hidden shadow-lg hover:shadow-2xl transition duration-200 ease-in-out items-stretch"
                  }
                >
                  <div className="relative">
                    {postImageData && (
                      <S.PostImage
                        image={postImageData}
                        alt={"Nyhetsbild"}
                        objectFit={"cover"}
                      />
                    )}
                    <p className="absolute top-3 left-4 bg-metlab-500 text-white rounded-md p-2 text-xs">
                      {post.contentType.node.graphqlSingleName}
                    </p>
                  </div>
                  <div className="px-6 py-6">
                    <h3 className="line-clamp-2 text-2xl mt-0">{post.title}</h3>
                    <div
                      className="line-clamp-3 mt-3 mb-8"
                      dangerouslySetInnerHTML={{ __html: post.excerpt }}
                    ></div>
                  </div>
                  <div className="absolute bottom-4 left-6 text-gray-500 flex items-center text-xs">
                    <S.PostInfo>
                      {post.contentType.node.graphqlSingleName}
                    </S.PostInfo>{" "}
                    <div>{date}</div>
                  </div>
                </div>
              </S.Post>
            </Link>
          );
        })}
      </div>

      {/*
            <div className="pagination-container">

                <ReactPaginate
                previousLabel={'föregående'}
                nextLabel={'nästa'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                activeClassName={'active'}
                />

            </div>
             */}
    </div>
  );
};

export default NewsArchive;
